"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTabIndex = exports.optionRole = exports.classes = void 0;
var classes = {
  category: 'category',
  optionsContainer: 'options-container',
  option: 'option',
  optionIcon: 'option-icon',
  optionIconLarge: 'option-icon-large',
  optionIconSmall: 'option-icon-small',
  optionLabel: 'option-label',
  disabledOptionLabel: 'disabled-option-label',
  optionSublabel: 'option-sublabel',
  optionLabelSublabelContainer: 'option-label-sublabel-container',
  optionWithLabelSublabel: 'option-with-label-sublabel',
  optionWithLabel: 'option-with-label',
  optionLabelWithSublabel: 'option-label-with-sublabel',
  optionLabelAlone: 'option-label-alone',
  separator: 'separator',
  selectedOption: 'selected-option',
  highlightOption: 'highlight-option',
  highlightOptionLabel: 'highlight-option-label',
  grouped: 'grouped'
};
exports.classes = classes;
var optionRole = 'option';
exports.optionRole = optionRole;
var defaultTabIndex = '0';
exports.defaultTabIndex = defaultTabIndex;